import { assertNever } from '../../../../utils/assertNever.ts';
import { ExpressionType } from '../../IExpression.ts';
import { createExpressionType } from '../../IExpressionType.ts';
import { ConditionGroupExpressionSchema } from './ConditionGroupExpressionSchema.ts';
import {
  ConditionGroupOperator,
  type IConditionGroupExpression,
} from './IConditionGroupExpression.ts';

export const ConditionGroupExpressionType =
  createExpressionType<IConditionGroupExpression>({
    type: ExpressionType.ConditionGroup,
    schema: ConditionGroupExpressionSchema,
    evaluate(expression, scope) {
      switch (expression.operator) {
        /**
         * Se l'operatore è AND, allora il risultato è true se tutti i valori
         * delle condizioni sono true.
         * Supportiamo l'esecuzione lazy, quindi se una singola condizione è false,
         * allora il risultato è false.
         * In caso di condizioni vuote, il risultato è true.
         */
        case ConditionGroupOperator.And: {
          for (const condition of expression.conditions) {
            const value = scope.evaluate(condition) as boolean;
            if (!value) {
              return false;
            }
          }
          return true;
        }

        /**
         * Se l'operatore è OR, allora il risultato è true se almeno un valore
         * delle condizioni è true.
         */
        case ConditionGroupOperator.Or: {
          for (const condition of expression.conditions) {
            const value = scope.evaluate(condition) as boolean;
            if (value) {
              return true;
            }
          }
          return false;
        }

        default:
          assertNever(expression.operator);
      }
    },
    getReferences(expression, collect) {
      return expression.conditions.flatMap(collect);
    },
    toString(expression, toString) {
      return (
        '( ' +
        expression.conditions.map(toString).join(` ${expression.operator} `) +
        ' )'
      );
    },
  });
